import { memo } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import SmartRender from "containers/SmartRender";
import {
  makeSelectFormValues,
  makeSelectReportLostSimPayload,
  makeSelectPageValidations,
  makeSelectReplaceWithEsimMessageData
} from "ducks/selectors";
import { submitReplaceSim } from "ducks/actions";
import { forms } from "utils/constants";

const mapStateToProps = (state, props) =>
  createStructuredSelector({
    formValues: makeSelectFormValues(forms.REPORT_LOST_SIM_FORM),
    payload: makeSelectReportLostSimPayload(),
    formValidations: makeSelectPageValidations(forms.REPORT_LOST_SIM_FORM),
    messageData: makeSelectReplaceWithEsimMessageData()
  });

export const mapDispatchToProps = dispatch => {
  return {
    onSubmit: (navigate, payload) => {
      dispatch(
        submitReplaceSim(payload, (result, error) => {
          if (!error) {
            try {
              navigate();
            } catch (err) {
              console.error("Error on submitReplaceSim callback", err);
            }
          } else {
            console.error("Error on submitReplaceSim callback", error);
          }
        })
      );
    }
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect, memo)(SmartRender);
